<div class="item-grabber">
  <rt-icon name="drag-vertical" />
</div>

<div class="item-content">
  @if (!titleEditorOpen) {
    <div class="item-title-actions">
      <div class="item-title">
        {{ title }}
      </div>
      @if (editable) {
        <div class="item-actions">
          <rt-group>
            @if (renamable) {
              <rt-icon-button
                (click)="onEditItemClick()"
                iconName="edit"
                shape="square"
                variant="plain"
              />
            }
            @if (removable) {
              <rt-icon-button
                [loading]="processing"
                (click)="onDeleteItemClick()"
                variant="plain"
                iconName="delete"
                shape="square"
                class="danger-on-hover"
              />
            }
          </rt-group>
        </div>
      }
    </div>
  }
  @if (titleEditorOpen) {
    <rt-list-sortable-form
      [value]="title"
      (cancelClick)="onCancelClick()"
      (saveClick)="onEditName($event)"
    />
  }
</div>
